import Link from 'next/link';
import Image from 'next/image';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useBlogTheme } from '@/hooks/useBlogTheme';

const DropDown = ({ visible, setVisible, navlist, dark }) => {
  const isMobile = useIsMobile();
  const { isBlogLightTheme } = useBlogTheme();

  if (isMobile) {
    return (
      <div
        className={`backdrop-blur-sm flex flex-col gap-4 transition-all duration-300 ease-in-out ${
          visible
            ? 'max-h-screen overflow-visible py-4 '
            : 'max-h-0 overflow-hidden'
        }`}
      >
        {navlist?.map((item, index) => {
          return (
            <Link
              key={index}
              prefetch={false}
              href={item?.url}
              onClick={() => setVisible(false)}
            >
              <div
                className={`rounded-xl group w-full ${
                  visible && 'animate-fade-in-down'
                }  border  hover:border-[#3cafc1] transition-all duration-150 px-4 py-4 relative flex items-start justify-center ${
                  isBlogLightTheme ? 'border-gray-200 bg-white' : 'border-white/20 bg-[#020c0d]'
                }`}
              >
                <Image
                  alt="img"
                  src={'/assets/arrow.svg'}
                  width={200}
                  height={300}
                  className="top-4 right-5 absolute w-4 transition-all group-hover:translate-x-1 duration-300"
                />

                <div>
                  <h1
                    className={`font-semibold text-lg ${
                      isBlogLightTheme ? 'text-black' : 'text-white'
                    }`}
                  >
                    {item?.heading}
                  </h1>
                  <p
                    className={`mt-1 font-light  text-sm line-clamp-2 ${
                      isBlogLightTheme ? 'text-gray-500' : 'text-gray-300'
                    }`}
                  >
                    {item?.description}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    );
  }

  if (!isMobile)
    return (
      <div
        className={`absolute w-full backdrop-blur-sm max-w-[90vw] mx-auto z-[999] mt-[2px] rounded-xl px-10 gap-3 ${
          visible
            ? 'max-h-screen overflow-visible py-5'
            : 'max-h-0 overflow-hidden'
        } grid grid-cols-2 transition-all duration-300 ease-in-out left-0 right-0 top-20 `}
      >
        {navlist?.map((item, index) => {
          return (
            <Link
              key={index}
              prefetch={false}
              href={item?.url}
              onClick={() => setVisible(false)}
            >
              <div
                className={`rounded-xl group w-full ${
                  visible && 'animate-fade-in-down'
                }  border border-white/20 hover:border-[#3cafc1] transition-all duration-150 px-8 py-4 h-[110px] relative flex items-start justify-center ${
                  isBlogLightTheme
                    ? 'border-gray-200 bg-white'
                    : 'border-white/20 bg-[#020c0d]'
                }`}
              >
                <Image
                  alt="img"
                  src={'/assets/arrow.svg'}
                  width={200}
                  height={300}
                  className="top-4 right-5 absolute w-4 transition-all group-hover:translate-x-1 duration-300"
                />

                <div>
                  <h1
                    className={`font-semibold text-lg ${
                      isBlogLightTheme ? 'text-black' : 'text-white'
                    }`}
                  >
                    {item?.heading}
                  </h1>
                  <p
                    className={`mt-1 font-light  text-sm line-clamp-2 ${
                      isBlogLightTheme ? 'text-gray-500' : 'text-gray-300'
                    }`}
                  >
                    {item?.description}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    );
};

export default DropDown;
